import { endpointQuery } from '../../common';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import {
  apiActions as commonApiActions,
  apiResourceActionCreator
} from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_BUSINESS_ACTIVITIES: (businessId, yearsOffset, filter) => ({
      businessId,
      yearsOffset,
      filter
    }),
    API: {
      GET_BUSINESS_ACTIVITIES: apiResourceActionCreator('businessActivities')
    }
  }
});

export const apiAction = (authToken, payload) => commonApiActions.authenticated.get(
    `${API_ENDPOINT}/businesses/${payload.businessId}/activities${endpointQuery(
      {
        ...(payload.filter || {}),
        ...(payload.yearsOffset !== undefined
          ? { yearsOffset: payload.yearsOffset }
          : {})
      }
    )}`,
    authToken,
    action.admin.api.getBusinessActivities
  );

function* getBusinessActivities(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'getBusinessActivities',
  action: action,
  sagas: getBusinessActivities,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingBusinessActivities: true
    }),
    success: (state, action) => ({
      ...state,
      isFetchingBusinessActivities: false,
      businessActivities: state.businessActivities
        ? {
            ...action.payload.businessActivities,
            result: state.businessActivities.result.concat(
              action.payload.businessActivities.result
            )
          }
        : action.payload.businessActivities
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingBusinessActivities: false
    })
  }
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getBusinessActivities.js